'use client'

import {ReactNode, useEffect, useState} from 'react'
import {usePlayButton} from '../game-image-and-play-btn/play-btn/play-button-context'

type Props = {
  children: ReactNode
}

const GameplayerVisibilityProvider = ({children}: Props) => {
  const {gameScreenShown} = usePlayButton()
  const [startPreload, setStartPreload] = useState(false)

  useEffect(() => {
    let cancelTimeout: (() => void) | null = null

    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(() => setStartPreload(true))
      cancelTimeout = () => cancelIdleCallback(id)
    } else {
      const timeoutId = setTimeout(() => setStartPreload(true), 1000)
      cancelTimeout = () => clearTimeout(timeoutId)
    }

    return () => {
      if (cancelTimeout) cancelTimeout()
    }
  }, [])

  return (
    <div
      className='transition-all duration-300'
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        visibility: gameScreenShown ? 'visible' : 'hidden',
        opacity: gameScreenShown ? 1 : 0,
        zIndex: gameScreenShown ? 10 : -1,
        pointerEvents: gameScreenShown ? 'auto' : 'none',
      }}
    >
      {startPreload && children}
    </div>
  )
}

export default GameplayerVisibilityProvider
